import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceService } from '../../service.service';

interface RfrResponsibleEmployee {
  department_id: string;
  department_name?: string;
  rfr_responsible_employee_id?: string;
  rfr_responsible_employee_name?: string;
}

@Component({
  selector: 'app-master-for-rfr-listing',
  templateUrl: './master-for-rfr-listing.component.html',
  styleUrls: ['./master-for-rfr-listing.component.css']
})
export class MasterForRfrListingComponent implements OnInit {
  rfrList: RfrResponsibleEmployee[] = [];
  filteredRfrList: RfrResponsibleEmployee[] = [];

  isLoading = false;
  loadError: string | null = null;

  searchText = '';

  constructor(
    private apiService: ServiceService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadRfrList();
  }

   goBack(): void {
  this.router.navigate(['admin/hrm-menu/vacation-monitoring'], {
    state: { returnToSettings: true }
  });
}

  loadRfrList(): void {
    this.isLoading = true;
    this.loadError = null;

    this.apiService.ViewRfrResponsibleEmployees().subscribe({
      next: (res: any) => {
        this.isLoading = false;
        if (res && res.success && Array.isArray(res.data)) {
          this.rfrList = res.data;
          this.applyFilters();
        } else {
          this.rfrList = [];
          this.filteredRfrList = [];
          this.loadError = 'Unable to load RFR responsible employees.';
        }
      },
      error: (err: any) => {
        console.error('Error loading RFR list:', err);
        this.isLoading = false;
        this.rfrList = [];
        this.filteredRfrList = [];
        this.loadError = 'Failed to load RFR data from server.';
      }
    });
  }

  reload(): void {
    this.loadRfrList();
  }

  applyFilters(): void {
    const term = this.searchText.trim().toLowerCase();

    if (!term) {
      this.filteredRfrList = [...this.rfrList];
      return;
    }

    this.filteredRfrList = this.rfrList.filter((r) => {
      const dept = (r.department_name || '').toLowerCase();
      const emp = (r.rfr_responsible_employee_name || '').toLowerCase();
      return dept.includes(term) || emp.includes(term);
    });
  }

  editRfr(item: RfrResponsibleEmployee): void {
    this.router.navigate(['/admin/rfr-edit-page'], {
      queryParams: { department_id: item.department_id }
    });
  }

  onRowClick(item: RfrResponsibleEmployee): void {
    // Hook for future detail view if needed
  }

  trackByRfr(index: number, item: RfrResponsibleEmployee): string {
    return item.department_id || index.toString();
  }
}